const Committee = ({ heading,description,people }) => {
  return (
    <div className="bg-white py-14 sm:py-14">
      <div className="mx-auto grid max-w-7xl gap-20 px-6 lg:px-8 xl:grid-cols-3">
        <div className="max-w-xl">
          <h2 className="text-pretty text-3xl tracking-tight text-gray-900 sm:text-4xl">
            {heading}
          </h2>
          <p className="mt-6 text-md md:text-lg text-gray-600">
            {description}
          </p>
        </div>
        <ul className="grid gap-x-8 gap-y-12 sm:grid-cols-2 sm:gap-y-16 xl:col-span-2">
          {people.map((person) => (
            <li key={person.name}>
              <div className="flex items-start gap-x-6 ">
                <img
                  alt={person.name}
                  src={person.imageUrl}
                  className="w-20 h-20 object-cover rounded-full "
                />
                <div>
                  <h3 className="text-base/7 font-semibold tracking-tight text-gray-900">
                    {person.name}
                  </h3>
                  <p className="text-sm/6 font-semibold text-indigo-600">
                    {person.role}
                  </p>
                  <p className="mt-2 text-sm text-gray-600">
                    {person.designation}
                  </p>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Committee;
